import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { Step, UserFestaEntryDraftData } from '@/types/festaEntries';

type FestaEntryThanks = {
    festa_entry_name: string;
    schedule_labels: string[];
    location_name: string;
    festa_entry_type_name: string;
    entry_date_time: string;
    email: string;
};

type FestaEntryStore = {
    thanksInfo: FestaEntryThanks | null;
    setThanksInfo: (info: FestaEntryThanks | null) => void;
    clearThanksInfo: () => void;

    draft: UserFestaEntryDraftData | null;
    step: Step | null;
    setDraft: (draft: UserFestaEntryDraftData) => void;
    patchDraft: (partial: Partial<UserFestaEntryDraftData>) => void;
    clearDraft: () => void;
    setStep: (step: Step | null) => void;
};

export const useFestaEntryStore = create<FestaEntryStore>()(
    persist(
        (set, get) => ({
            thanksInfo: null,
            setThanksInfo: (info) => set({ thanksInfo: info }),
            clearThanksInfo: () => set({ thanksInfo: null }),

            draft: null,
            step: null,
            setDraft: (draft) => set({ draft }),
            patchDraft: (partial) => {
                const current = get().draft ?? ({} as UserFestaEntryDraftData);
                set({ draft: { ...current, ...partial } });
            },
            clearDraft: () => set({ draft: null }),
            setStep: (step) => set({ step }),
        }),
        {
            name: 'KEY-FESTA-ENTRY',
            storage: typeof window !== 'undefined' ? createJSONStorage(() => localStorage) : undefined,
        },
    ),
);
